/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServicePackagePlanFeature
 */
export interface ServicePackagePlanFeature {
    /**
     * 
     * @type {string}
     * @memberof ServicePackagePlanFeature
     */
    readonly name: string;
    /**
     * 
     * @type {string}
     * @memberof ServicePackagePlanFeature
     */
    readonly description: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServicePackagePlanFeature
     */
    readonly activated: boolean;
}

/**
 * Check if a given object implements the ServicePackagePlanFeature interface.
 */
export function instanceOfServicePackagePlanFeature(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "activated" in value;

    return isInstance;
}

export function ServicePackagePlanFeatureFromJSON(json: any): ServicePackagePlanFeature {
    return ServicePackagePlanFeatureFromJSONTyped(json, false);
}

export function ServicePackagePlanFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServicePackagePlanFeature {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'activated': json['activated'],
    };
}

export function ServicePackagePlanFeatureToJSON(value?: ServicePackagePlanFeature | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

